import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Models
import IQuiz from 'models/Quiz';
// Components
import QuestionItem from './QuestionItem';
import PageTypes from 'types/PageTypes';

const QuestionsList:FC = () => {
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const showQuestion = (quiz?.pages || []).filter(page => page.type === PageTypes.Question).length > 1;

  return (
    <div>
      {quiz.questions.map(question => (
        <QuestionItem
          key={question.ref}
          question={question}
          showQuestion={showQuestion}
        />
      ))}
    </div>
  )
}

export default QuestionsList;
